import ColorContrastChecker from "color-contrast-checker";

export const isContrast = (colorA: string, colorB: string, ratio?: number) => {
  try {
    const contrast = new ColorContrastChecker();

    if (!!ratio) {
      return contrast.isLevelCustom(colorA, colorB, ratio);
    }

    return contrast.isLevelAA(colorA, colorB);
  } catch (e) {
    // The lib will throw error if the color is invalid, need to catch it by returning false
    return false;
  }
};
